// packages/api/src/axiosInternal.ts
import axios from 'axios';

const axiosInternal = axios.create({
  baseURL: '', // برای internal API Routes مثل /api/*
  timeout: 10000,
  withCredentials: true,
});

// هندل 401 برای استفاده در API Route یا SSR
axiosInternal.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('[axiosInternal] Unauthorized - احتمالاً نیاز به logout است.');

      // اینجا هم مثل axiosServer فقط لاگ یا یک اکشن مشترک
    }

    return Promise.reject(error);
  }
);

export default axiosInternal;
